import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';

import { Follow } from '../Follow';
import type { Subscriptions_subscription } from './__generated__/index.graphql';

type Props = {
  subscriptions: Subscriptions_subscription[];
};

export const Subscriptions = ({ subscriptions }: Props) => {
  return (
    <Vertical>
      {subscriptions.map(f => (
        <Follow key={f.slug} subscription={f} />
      ))}
    </Vertical>
  );
};

Subscriptions.fragments = {
  subscription: gql`
    fragment Subscriptions_subscription on EmailSubscription {
      slug
      ...Follow_subscription
    }
    ${Follow.fragments.subscription}
  ` as TypedDocumentNode<Subscriptions_subscription>,
};
